import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ModalDirective } from 'ngx-bootstrap/modal';
import { HelperService } from '../../Services/helper.service';
import { DataManipService } from '../../Services/data-manip.service';
import { ActivatedRoute, Router } from '@angular/router';
import { ConfigSettingService } from '../../Services/config-setting.service';
import { CommonService } from '../../Services/common.service';
import { EncrptDecreptService } from '../../Services/encrpt-decrept.service';
const buzzer = '../../../assets/sound/time-buzzer.mp3';

declare var $;
@Component({
  selector: 'app-mind-tendency-test',
  templateUrl: './mind-tendency-test.component.html',
  styleUrls: ['./mind-tendency-test.component.scss']
})

export class MindTendencyTestComponent implements OnInit {

  @ViewChild('mindTendencyKeywordModal', { static: false }) public mindTendencyKeywordModal: ModalDirective;
  @ViewChild('successModal', { static: false }) public successModal: ModalDirective;
  @ViewChild('resultModal', { static: false }) public resultModal: ModalDirective;
  @ViewChild('trialRoundModal', { static: false }) public trialRoundModal: ModalDirective;
  @ViewChild('mindTendencyComfirmation', { static: false }) public mindTendencyComfirmation: ModalDirective;

  mindTendencyRound: number = -1;
  trialMindTendencyRound: number = -1;
  actualTestTotalRound: number = 0;
  trialTestTotalRound: number = 0;
  countDownTimer: number = 0;
  timeForTrialTest: number = 0;
  timeForActualTest: number = 0;
  alertRemainingTimeForActualTest: number = 0;
  startTestCountDownSeconds: number = 0;
  totalScore: number = 0;
  dynamic: number = 0;
  maxRound: number = 10;
  successModalMessage: any;
  warningMessage: string = '';
  reslutHeaderMessage: string = '';
  reslutMessage: string = '';
  successModalHeading: string = 'Congratulations!';
  clueWordPattern: string = '^[a-zA-Z]{2,20}$';
  testType: 'trial' | 'actual';
  timeoutMsgForTrialTest:any []=[] ;
  showCountTimer: string = '';
  showCountDown: string = '';
  selectedLanguageForTest: string = '';
  duringTestInstr: string = '';
  duringTestPopupInstr: string = '';

  visibleCountTimer: boolean = false;
  isTimeOver: boolean = false;
  lessTimeActivate: boolean = false;
  lessTimeActivateMeaasge: boolean = false;
  isScrollDown: boolean = false;
  isShowCountDownClock: boolean = false;
  showResultTable: boolean = false;

  audio: any;
  countDownTimeInterval: any;
  countDownInterval: any;

  trialMindTendencyJson: any = {}
  mindTendencyJson: any = {}
  connectionRootIndexObj: any = {}
  enteredClueWords: any[] = [];
  resultObject: any = '';
  disabledImages: boolean = false;
  afterTrialTestJson = {
    "trial": [
      {
        "srno": 1,
        "texte": "Your actual Test will start now.",
        "textm": "आता तुमची प्रत्यक्ष चाचणी सुरु होईल.",
        "texth": "इसके बाद आपका असली परीक्षण शुरु होगा।"
      },
      {
        "srno": 2,
        "texte": "The time for Test is 15 minutes. (Timer is given on the screen.)",
        "textm": "प्रत्यक्ष चाचणी १५ मिनिटांची आहे. त्याचा टायमर शेजारी दिसेल.",
        "texth": "इस परीक्षण की अवधि 15 मिनट है। इसका टाइमर, बगल में दिखाई देगा।"
      },
      {
        "srno": 3,
        "texte": "You are expected to write as many words as possible.",
        "textm": "प्रत्यक्ष चाचणीमध्ये तुम्ही जास्तीत जास्त शब्द लिहिणे अपेक्षित आहे.",
        "texth": "इस परीक्षण में, आपसे अधिकतम शब्द लिखे जाने अपेक्षा की जाती है।"
      },
      {
        "srno": 4,
        "texte": "Good Luck!!",
        "textm": "त्यासाठी शुभेच्छा! ",
        "texth": "परीक्षण के लिए शुभकामनाएं!!"
      }
    ],
    "timeOutMsg": [
      {
        "texte": "Your trial test time is over!",
        "textm": "Your trial test time is over!",
        "texth": "Your trial test time is over!"
      }
    ]
  }

  clueWordObj: any = {
    clueword1: { word: '', disabled: false, cssstyle: '' },
    clueword2: { word: '', disabled: true, cssstyle: 'disabled' },
    clueword3: { word: '', disabled: true, cssstyle: 'disabled' },
    clueword4: { word: '', disabled: true, cssstyle: 'disabled' },
    clueword5: { word: '', disabled: true, cssstyle: 'disabled' },
    clueword6: { word: '', disabled: true, cssstyle: 'disabled' },
    clueword7: { word: '', disabled: true, cssstyle: 'disabled' },
    clueword8: { word: '', disabled: true, cssstyle: 'disabled' },
    clueword9: { word: '', disabled: true, cssstyle: 'disabled' },
    clueword10: { word: '', disabled: true, cssstyle: 'disabled' }
  }

  constructor(private helper: HelperService, private commonServices: CommonService, private encryptService: EncrptDecreptService, public dataManipSrvc: DataManipService, private activatedRoute: ActivatedRoute, private common: CommonService, private config: ConfigSettingService, private router: Router) { }

  ngOnInit(): void {
    console.log('in on init on mindTendency');
    
    this.getTestData();
    // this.getRequiredDataForTest();
    // if (this.timeForTrialTest != 0) {
    //   this.countDownTimer = this.timeForTrialTest
    //   this.countDownTimeStart();
    // }
    // console.log(this.dataManipSrvc.testInstructions);
    // console.log(this.dataManipSrvc.requireddata);


    $(".modal-dialog.draggable-modal").draggable();
    setTimeout(() => {
      this.startTestByDefault('trial')
    }, 1000);
  }

  ngAfterViewInit(): void {
    document.addEventListener("scroll", (event) => {
      this.isScrollDown = this.helper.scrollHeightCondition();
    });
  }

  getTestData() {
    this.activatedRoute.queryParams.subscribe(params => {
      let data = JSON.parse(params['data']);
      // console.log("getTestData", data);

      this.trialMindTendencyJson = data['testpattern']['trial'];
      this.mindTendencyJson = data['testpattern']['actual'];
      this.selectedLanguageForTest = data['userselectedtestlanguadge'];

      this.duringTestInstr = this.dataManipSrvc.testInstructions['duringtestinstr'];
      this.duringTestPopupInstr = this.dataManipSrvc.testInstructions['duringtestpopupinstr'];
    })

  }

  getRequiredDataForTest() {
    
    this.actualTestTotalRound = this.dataManipSrvc.requireddata['actualTestRound'];
    this.trialTestTotalRound = this.dataManipSrvc.requireddata['trailTestRound'];
    this.timeForTrialTest = this.dataManipSrvc.requireddata['timeForTrialTest'];
    this.timeForActualTest = this.dataManipSrvc.requireddata['timeForActualTest'];
    this.alertRemainingTimeForActualTest = this.dataManipSrvc.requireddata['actualTestAlertTime'];
    this.startTestCountDownSeconds = this.dataManipSrvc.requireddata['startTestCountDown'];
    this.connectionRootIndexObj = this.dataManipSrvc.requireddata['connectionRootIndex'];
  }

  scrollDown() {
    this.isScrollDown = this.helper.scrollHeightCondition();

    window.scrollBy({
      top: this.isScrollDown ? -window.scrollY : 300,
      behavior: 'smooth'
    });
  }

  modalClassHandle() {
    const element = document.getElementById('app-id');
    element.classList.remove('modal-open');
  }

  startTestByDefault(testType: 'trial' | 'actual') {
    this.testType = testType;
    this.mindTendencyRound = 1;
    this.trialMindTendencyRound = 1;
    if (this.testType == 'trial') {
      this.trialRoundModal.show();
    } else { this.mindTendencyKeywordModal.show() }
    this.modalClassHandle();
    if (testType == 'trial') {
      this.trialMindTendencyJson[this.trialMindTendencyRound]['imagename'] = 'green';
      this.trialMindTendencyJson[this.trialMindTendencyRound]['cssclass'] = 'active-sec';
      this.dynamic = this.trialMindTendencyRound;
    } else {
      $(`div[tabindex=1]`).focus();
      this.mindTendencyJson[this.mindTendencyRound]['imagename'] = 'green';
      this.mindTendencyJson[this.mindTendencyRound]['cssclass'] = 'active-sec';
      this.dynamic = this.mindTendencyRound;
    }
    this.setAutoFocus(1);
  }

  setAutoFocus(num: number) {
    let ele = document.getElementById(`clueword-${num}`);
    setTimeout(() => {
      ele.focus();
    }, 1000);
  }

  countDownTimeStart() {
    this.countDownTimeInterval = setInterval(() => {
      if (this.testType == 'actual' && this.countDownTimer == this.alertRemainingTimeForActualTest) {
        this.audio.play();
        this.lessTimeActivate = true;
        this.lessTimeActivateMeaasge = true;
      }
      if (this.countDownTimer == 0) {
        clearInterval(this.countDownTimeInterval);
        this.countDownTimer = 0;
        this.lessTimeActivate = false;
        this.lessTimeActivateMeaasge = false;
        this.showCountTimer = '';
        this.visibleCountTimer = false;
        if (this.audio) {
          this.audio.pause();
          this.audio.currentTime = 0;
        }
        if (this.testType == 'actual') {
          this.showResultTable = true;
          this.isTimeOver = true;
          this.mindTendencyKeywordModal.hide();
          this.reslutHeaderMessage = 'Opps! Your time is over.';
          this.reslutMessage = "1. You will see the 'Computerized Report' of the Test on the screen. <br> 2. You will also receive this same Report, in your email.";
          this.resultModal.show();
        } else if (this.testType == "trial") {
          this.isTimeOver = true;
          this.mindTendencyKeywordModal.hide();
          this.successModalHeading = 'Opps!';
          this.successModalMessage = this.afterTrialTestJson['timeOutMsg'];
          console.log('successModalMessage',this.successModalMessage);
          
          this.successModal.show();
        }
        return;
      } else {
        this.countDown(this.countDownTimer, 'timer')
      }
    }, 1000)
  }

  countDown(time, type) {
    let min = Math.floor(time / 60).toString();
    let sec = Math.floor(time % 60).toString();

    min = min.length == 1 ? ("0" + min) : min;
    sec = sec.length == 1 ? (type == 'timer' ? "0" + sec : sec) : sec;

    if (type == 'timer') {
      this.showCountTimer = `${min + ':' + sec}`;
      this.visibleCountTimer = true;
      if (min == '00' && sec == '00') {
        return;
      }
      this.countDownTimer--;
    } else {
      this.showCountDown = sec;
      if (sec == '0') {
        this.isShowCountDownClock = false;
        return;
      }
      this.startTestCountDownSeconds--;
    }
  }

  continueForActualRound() {
    this.testType = 'actual';
    this.isShowCountDownClock = true;
    this.dynamic = 0;

    this.countDownInterval = setInterval(() => {

      if (this.startTestCountDownSeconds == 0) {
        this.startTestCountDownSeconds = 0;
        this.countDownTimer = this.timeForActualTest;
        this.isShowCountDownClock = false;
        this.clearForm()
        this.countDownTimeStart();
        this.startTestByDefault('actual')
        this.audio = new Audio(buzzer);

        clearInterval(this.countDownInterval);
        return;
      } else {
        this.countDown(this.startTestCountDownSeconds, 'countdown')
      }
    }, 1000)
  }

  clickOkToSaveClueWords(option) {
    this.msgFlag = false;
    this.mindTendencyKeywordModal.hide();
    this.mindTendencyComfirmation.hide();

    const Obj = {};
    for (let item in this.clueWordObj) {
      Obj[item] = this.clueWordObj[item]['word']
    }

    const cluewordList = Object.values(Obj);

    this.enteredClueWords = [];
    cluewordList.forEach((item) => {
      if (item) this.enteredClueWords.push(item);
    })
    const randomCluewordForNextRound = this.getRandomClueWord(this.enteredClueWords);

    const getClueWordIndex = cluewordList.indexOf(randomCluewordForNextRound);
    const newIndexClueWordList = this.setConnetionRootIndex(cluewordList, getClueWordIndex, this.connectionRootIndexObj[this.mindTendencyRound]);

    if (this.testType == 'actual') {

      this.mindTendencyJson[this.mindTendencyRound]['userenteredword'] = newIndexClueWordList;
      this.mindTendencyJson[this.mindTendencyRound]['userenteredwordcount'] = this.enteredClueWords.length;
      this.totalScore += this.mindTendencyJson[this.mindTendencyRound]['userenteredwordcount'];
      this.clueWordObj[`clueword${this.mindTendencyRound}`]['disabled'] = false;

      this.mindTendencyRound++;
      // $(`div[tabindex=${this.mindTendencyRound}]`).focus();
      this.dynamic = this.mindTendencyRound > this.actualTestTotalRound ? this.actualTestTotalRound : this.mindTendencyRound;

      this.mindTendencyJson[this.mindTendencyRound - 1]['imagename'] = 'blue';
      this.mindTendencyJson[this.mindTendencyRound - 1]['cssclass'] = 'complete-sec';

      if ((this.mindTendencyRound > this.actualTestTotalRound) || option == 'finish') {
        this.saveTestData();
        this.showResultTable = true;
        //"Congrulations! Your test is over."
        //"1. You will see the 'Computerized Report' of the Test on the screen. <br> 2. You will also receive this same Report, in your email.";

        this.reslutHeaderMessage = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['finalmessage']['headinge'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['finalmessage']['headingm'] : this.duringTestInstr['finalmessage']['headingh'];
        this.reslutMessage = this.selectedLanguageForTest == 'e' ? this.duringTestInstr['finalmessage']['descriptione'] : this.selectedLanguageForTest == 'm' ? this.duringTestInstr['finalmessage']['descriptionm'] : this.duringTestInstr['finalmessage']['descriptionh'];
        clearInterval(this.countDownTimeInterval);
        this.countDownTimer = 0;
        this.showCountTimer = '';
        this.visibleCountTimer = false;
        this.resultModal.show();
        return;
      }

      this.mindTendencyJson[this.mindTendencyRound]['clueword'] = randomCluewordForNextRound;
      this.mindTendencyJson[this.mindTendencyRound]['imagename'] = 'green';
      this.mindTendencyJson[this.mindTendencyRound]['cssclass'] = 'active-sec';
    } else {
      this.trialMindTendencyJson[this.trialMindTendencyRound]['userenteredword'] = newIndexClueWordList;
      this.trialMindTendencyJson[this.trialMindTendencyRound]['userenteredwordcount'] = this.enteredClueWords.length;
      this.clueWordObj[`clueword${this.trialMindTendencyRound}`]['disabled'] = false;

      this.trialMindTendencyRound++;
      $(`div[tabindex=${this.trialMindTendencyRound}]`).focus();
      this.dynamic = this.trialMindTendencyRound > this.trialTestTotalRound ? this.trialTestTotalRound : this.trialMindTendencyRound;


      this.trialMindTendencyJson[this.trialMindTendencyRound - 1]['imagename'] = 'blue';
      this.trialMindTendencyJson[this.trialMindTendencyRound - 1]['cssclass'] = 'complete-sec';

      if (this.trialMindTendencyRound > this.trialTestTotalRound) {
        this.successModal.show();
        this.successModalHeading = this.getHeaderMsgForTest();
        this.successModalMessage = this.afterTrialTestJson['trial'];

        this.countDownTimer = 0;
        this.lessTimeActivate = false;
        this.lessTimeActivateMeaasge = false;
        this.showCountTimer = '';
        this.visibleCountTimer = false;
        clearInterval(this.countDownTimeInterval);
        return;
      }

      this.trialMindTendencyJson[this.trialMindTendencyRound]['clueword'] = randomCluewordForNextRound;
      this.trialMindTendencyJson[this.trialMindTendencyRound]['imagename'] = 'green';
      this.trialMindTendencyJson[this.trialMindTendencyRound]['cssclass'] = 'active-sec';
    }

    this.clearForm();

    setTimeout(() => {
      this.mindTendencyKeywordModal.show();
      this.modalClassHandle()
      this.setAutoFocus(1);
    }, 1000);
  }

  getHeaderMsgForTest() {
    let msg = '';
    if (this.selectedLanguageForTest == 'e') {
      msg = 'The Trial Round is over.';
    } else if (this.selectedLanguageForTest == 'h') {
      msg = 'आपका ट्रायल राउंड पूरा हो गया है।';
    } else {
      msg = 'तुमची सराव चाचणी पूर्ण झाली.'
    }
    return msg;
  }




  getRandomClueWord(clueword) {
    const random = Math.floor(Math.random() * clueword.length);
    return clueword[random];
  }

  setConnetionRootIndex(arr, fromIndex, toIndex) {
    var element = arr[fromIndex];
    arr.splice(fromIndex, 1);
    arr.splice(toIndex, 0, element);
    return arr;
  }

  clearForm() {
    for (let item in this.clueWordObj) {
      this.clueWordObj[item]['word'] = "";
      this.clueWordObj[item]['disabled'] = true;
      this.clueWordObj[item]['cssstyle'] = 'disabled';
    }
    this.clueWordObj.clueword1.disabled = false;
    this.clueWordObj.clueword1.cssstyle = '';
  }

  clickOkSuccessModal() {
    this.countDownTimer = 0;
    this.showCountTimer = '';
    this.visibleCountTimer = false;
  }

  msgFlag: boolean = false;

  getTabEvent(eve: any, inputNum: number, event?: any) {
    console.log(eve);
    this.msgFlag = false;
    if ( eve == 'focusout' || eve.key == 'Tab' || eve.code == 'Enter') {
      let val = event?.target?.value;
      this.msgFlag = val?.length > 1 ? false : true;
    }


    if (eve.key == 'Tab' || eve.code == 'Enter' || (eve == 'focusout' && this.clueWordObj[`clueword${inputNum}`]['word'])) {
      if (eve.code == 'Enter') {
        let ele = document.getElementById(`clueword-${inputNum + 1}`);
        setTimeout(() => {
          ele.focus();
        }, 500);

      }
      if (inputNum > 1) {
        this.clueWordObj[`clueword${inputNum - 1}`]['cssstyle'] = 'text-filled';
        this.clueWordObj[`clueword${inputNum - 1}`]['disabled'] = true;
        if (this.clueWordObj[`clueword${inputNum - 1}`]['word'].length <= 1) {
          this.clueWordObj[`clueword${inputNum - 1}`]['disabled'] = false;
          this.clueWordObj[`clueword${inputNum - 1}`]['cssstyle'] = 'invalid';
        }
      }

      this.clueWordObj[`clueword${inputNum}`]['disabled'] = this.clueWordObj[`clueword${inputNum}`]['word'] ? true : false;
      this.clueWordObj[`clueword${inputNum}`]['cssstyle'] = 'text-filled';
      if (this.clueWordObj[`clueword${inputNum}`]['word'].length <= 1) {
        this.clueWordObj[`clueword${inputNum}`]['disabled'] = false;
        this.clueWordObj[`clueword${inputNum}`]['cssstyle'] = 'invalid';
      }
      this.clueWordObj[`clueword${inputNum + 1}`]['disabled'] = false;
      this.clueWordObj[`clueword${inputNum + 1}`]['cssstyle'] = '';
    }
  }

  restrictCharacters(eve: any) {
    if (this.charactersList(eve.key)) {
      eve.preventDefault();
    }
  }

  charactersList(str) {
    const invalidChars = ["\\", "1", "2", "3", "4", "5", "6", "7", "8", "9", "0", "`", "~", "!", "@", "#", "$", "%", "^", "&", "*", "(", ")", "-", "_", "=", "+", "[", "]", "{", "}", "|", ";", ":", "'", '"', "<", ">", ",", ".", "/", "?", " "];

    return invalidChars.includes(str);
  }

  closeAlert() {
    this.lessTimeActivateMeaasge = false;
  }

  saveTestData() {

    this.disabledImages = true;
    for (let key in this.mindTendencyJson) {
      delete this.mindTendencyJson[key]['imagename'];
      delete this.mindTendencyJson[key]['cssclass'];
      let arr = this.mindTendencyJson[key]["userenteredword"].filter((element: any) => element !== '');
      this.mindTendencyJson[key]["userenteredword"] = arr;
    }
    this.mindTendencyJson.totalPoints = this.totalScore;
    this.mindTendencyJson.userAge = this.dataManipSrvc.age;
    let params = {

      testid: this.encryptService.encrypt(this.dataManipSrvc.testId + ""),
      usertestid: this.encryptService.encrypt(this.dataManipSrvc.usertestid + ""),
      // userid:this.dataManipSrvc.userId,
      // selectedLanguage: this.dataManipSrvc.testLangugae, 
      testpaper: this.mindTendencyJson,
    }
    const apiUrl = this.config.getBaseUrl() + "dashtest/finishdashtest"
    this.common.postMethod(apiUrl, params).subscribe((successRep) => {
      if (successRep['errorCode'] == '000000') {
        this.resultObject = JSON.stringify(successRep['Data'])
      } else {
        console.log(successRep['errorDescription']);
      }
    })
  }

  finishTest() {
    let params =
    {
      "userid": this.encryptService.encrypt(this.dataManipSrvc.userId + ""),
      "usertestid": this.encryptService.encrypt(this.dataManipSrvc.usertestid + ""),
      "testid": this.encryptService.encrypt(this.dataManipSrvc.testId + "")
    };
    let apiUrl = this.config.getBaseUrl() + "dashtest/downloadResultPDF";
    this.commonServices.downloadReport(apiUrl, params).subscribe(successResp => {

      var blob = new Blob([successResp], { type: 'application/pdf' });
      var url = window.URL.createObjectURL(blob);
      window.open(url, "_blank");
      this.resultModal.hide();
      this.router.navigate(["/dashboard"], { queryParams: { testid: this.dataManipSrvc.testId, usertestid: this.dataManipSrvc.usertestid } });
    },
      err => {
        alert("Problem while downloading the file.");

        console.error(err);
      }
    );
  }

  openActualRoundModal(){
    this.getRequiredDataForTest();
    if (this.timeForTrialTest != 0) {
      this.countDownTimer = this.timeForTrialTest
      this.countDownTimeStart();
    }
    this.msgFlag = false;
    this.mindTendencyKeywordModal.show();
  }
}